module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"offense":"Offense","air":"Air","armorer":"Armorer","fire":"Fire","archery":"Archery","earth":"Earth","artillery":"Artillery","water":"Water"},"ru":{"offense":"Нападение","air":"Воздух","armorer":"Доспехи","fire":"Огонь","archery":"Стрельба","earth":"Земля","artillery":"Артиллерия","water":"Вода"}}')
  delete Component.options._Ctor
}
